export default function Carousel() {
  return (
    <section id="carousel" className="w-full py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            焦点专题
          </h2>
          <p className="text-foreground-600 text-sm mt-2">精选深度专题内容，一次看够同类型好片</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer">
            <div className="aspect-[4/3] w-full overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20collage%20with%20space%20and%20future%20technology%20themes%2C%20warm%20golden%20and%20deep%20space%20tones%2C%20epic%20movie%20poster%20style%2C%20dramatic%20composition%2C%20rich%20contrast&width=640&height=480&seq=carousel-01&orientation=landscape"
                alt="科幻巨制专题"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-1">科幻巨制 · 探索未知</h3>
              <p className="text-sm text-foreground-600 line-clamp-2">从《流浪地球》到《星际穿越》，精选全球顶级科幻大片，带你踏上跨越时空的视觉之旅。</p>
              <span className="inline-block mt-3 text-xs text-primary-600 font-medium">32部精选 →</span>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer">
            <div className="aspect-[4/3] w-full overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20drama%20cinematic%20collage%20with%20romantic%20and%20dramatic%20themes%2C%20soft%20warm%20lighting%2C%20elegant%20Korean%20aesthetic%2C%20emotional%20atmosphere%2C%20clean%20composition&width=640&height=480&seq=carousel-02&orientation=landscape"
                alt="韩剧精选专题"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-1">韩剧精选 · 高分必刷</h3>
              <p className="text-sm text-foreground-600 line-clamp-2">《黑暗荣耀》《请回答1988》《信号》等豆瓣高分韩剧一网打尽，追剧不停歇。</p>
              <span className="inline-block mt-3 text-xs text-primary-600 font-medium">64部精选 →</span>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer">
            <div className="aspect-[4/3] w-full overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Suspense%20thriller%20cinematic%20collage%20with%20mystery%20and%20crime%20themes%2C%20dark%20warm%20tones%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20film%20grain%20texture&width=640&height=480&seq=carousel-03&orientation=landscape"
                alt="悬疑烧脑专题"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-1">悬疑烧脑 · 极限反转</h3>
              <p className="text-sm text-foreground-600 line-clamp-2">高能反转、细思极恐的悬疑佳作合集，《漫长的季节》《隐秘的角落》等口碑神作。</p>
              <span className="inline-block mt-3 text-xs text-primary-600 font-medium">37部精选 →</span>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer">
            <div className="aspect-[4/3] w-full overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Anime%20cinematic%20collage%20with%20Japanese%20animation%20aesthetic%2C%20dynamic%20action%20scenes%2C%20vibrant%20warm%20colors%2C%20artistic%20composition%2C%20rich%20visual%20style&width=640&height=480&seq=carousel-04&orientation=landscape"
                alt="动漫热血专题"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-1">动漫热血 · 燃爆青春</h3>
              <p className="text-sm text-foreground-600 line-clamp-2">《鬼灭之刃》《进击的巨人》《咒术回战》等热门动漫全集收录，热血与感动并存。</p>
              <span className="inline-block mt-3 text-xs text-primary-600 font-medium">215部精选 →</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}